import React from "react";

const LABELS = {
	aeo: "AEO",
	geo: "GEO",
	shared: "AEO · GEO",
};

export default function SectionBadge({ type }) {
	return <span className={`section-badge section-badge--${type}`}>{LABELS[type]}</span>;
}
